import { render, staticRenderFns } from "./AddBlockBooking.vue?vue&type=template&id=4112a25b"
import script from "./AddBlockBooking.vue?vue&type=script&lang=js"
export * from "./AddBlockBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports